function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.00028H3.00028V1H1V3.00028ZM3.00028 3.00028H5.00056V1H3.00028V3.00028ZM5.00056 3.00028H7.00084V1H5.00056V3.00028ZM5.00056 5.00056H7.00084V3.00028H5.00056V5.00056ZM5.00056 7.00084H7.00084V5.00056H5.00056V7.00084ZM3.00028 7.00084H5.00056V5.00056H3.00028V7.00084ZM1 7.00084H3.00028V5.00056H1V7.00084ZM1 5.00056H3.00028V3.00028H1V5.00056Z",
  fill: "#2E82FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9994 11.0003H12.9997V9H10.9994V11.0003ZM8.99915 11.0003H10.9994V9H8.99915V11.0003ZM12.9997 11.0003H15V9H12.9997V11.0003ZM10.9994 15.0008H12.9997V13.0006H10.9994V15.0008ZM8.99915 13.0006H10.9994V11.0003H8.99915V13.0006ZM8.99915 15.0008H10.9994V13.0006H8.99915V15.0008ZM12.9997 15.0008H15V13.0006H12.9997V15.0008Z",
  fill: "#FF44B7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 11.0003H3.00028V9H1V11.0003ZM5.00056 11.0003H7.00084V9H5.00056V11.0003ZM5.00056 13.0006H7.00084V11.0003H5.00056V13.0006ZM3.00028 11.0003H5.00056V9H3.00028V11.0003ZM3.00028 13.0006H5.00056V11.0003H3.00028V13.0006ZM1 15.0008H3.00028V13.0006H1V15.0008ZM1 13.0006H3.00028V11.0003H1V13.0006Z",
  fill: "#F8B73E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99915 3.00028H10.9994V1H8.99915V3.00028ZM12.9997 7.00084H15V5.00056H12.9997V7.00084ZM10.9994 5.00056H12.9997V3.00028H10.9994V5.00056ZM12.9997 3.00028H15V1H12.9997V3.00028ZM8.99915 7.00084H10.9994V5.00056H8.99915V7.00084ZM8.99915 5.00056H10.9994V3.00028H8.99915V5.00056Z",
  fill: "#00DC82"
});

function SvgOkpcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkpcLogo);
export default __webpack_public_path__ + "static/media/okpc-logo.1b03497b.svg";
export { ForwardRef as ReactComponent };